<template>
  <b-modal :active="show" @close="toggle" class="modal">
    <div class="modal-content">
      <h2 class="title">Terms and Conditions (web)</h2>
      <div class="content is-medium">
        <a class="download" href="/documents/web-terms-and-conditions.pdf" download>Download this document</a>
        <embed src="/documents/web-terms-and-conditions.pdf" type="application/pdf" width="100%" height="90%">
      </div>
      <button type="button" @click="toggle" class="button is-primary is-fullwidth">Close</button>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: 'ModalWebTermsAndConditions',

  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  methods: {
    toggle() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style scoped>
.modal-content {
  background-color: white;
  border-radius: 10px;
  padding: 15px;
}

.download {
  font-size: 0.8rem;
}

.content {
  max-height: 70vh;
  height: 550px;
  overflow: auto;
}
</style>
